import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ResetValidationPayload } from "./@types";

const resetValidation = async(payload: ResetValidationPayload) => {
    const { data } = await apiInputService.post(
        "/activityItem/reset-validation", 
        payload
    );

    return data;
}

export const useResetActivityItemValidation = () => {
    return useMutation(resetValidation);
} 